import { render, staticRenderFns } from "./Forgotpass.vue?vue&type=template&id=377a97cc&scoped=true&"
import script from "./Forgotpass.vue?vue&type=script&lang=js&"
export * from "./Forgotpass.vue?vue&type=script&lang=js&"
import style0 from "./Forgotpass.vue?vue&type=style&index=0&id=377a97cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377a97cc",
  null
  
)

export default component.exports